import { render, staticRenderFns } from "./inspectionItemTitleManageList.vue?vue&type=template&id=8531cfee&scoped=true"
import script from "./inspectionItemTitleManageList.vue?vue&type=script&lang=js"
export * from "./inspectionItemTitleManageList.vue?vue&type=script&lang=js"
import style0 from "./inspectionItemTitleManageList.vue?vue&type=style&index=0&id=8531cfee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8531cfee",
  null
  
)

export default component.exports